export default "__VITE_ASSET__100f0201__"